
class Dialog {
  constructor(dialog) {
    this.dialog = dialog;
    if (!this.dialog) return;

    this.dialog.addEventListener('click', event => {
      if (event.target === event.currentTarget) {
        this.dialog.close();
      }
    });

    this.dialog.addEventListener('toggle', event => {
      if (event.newState === 'open') {
        window.dispatchEvent(new CustomEvent('dialog:open', { detail: this.dialog, bubbles: true }));
      }
    });

    const form = this.dialog.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => this.dialog.close());
    }
  }

  static prefetch(target) {
    const variantRadios = target.querySelector('variant-radios');
    if (!variantRadios || variantRadios._prefetchedHTML) return;

    const options = JSON.parse(variantRadios.dataset.options);
    const url = `${options.url}?variant=${options.productId}&section_id=theme-quick-shop`;
    variantRadios._prefetchedHTML = fetch(url).then(response => response.text());
  }

  static loadQuickShop(target) {
    const variantRadios = target.querySelector('variant-radios');
    return variantRadios?.handleVariantChange(null, true) ?? Promise.resolve();
  }
}

window.Dialog = Dialog;

window.initDialogs = function(container = document) {
  container = container ?? document;
  container.querySelectorAll('dialog:not([data-dialog-initialized])').forEach(dialog => {
    dialog.setAttribute('data-dialog-initialized', '');
    new Dialog(dialog);
  });

  container.querySelectorAll('[data-dialog-quickshop-trigger]:not([data-dialog-trigger-initialized])').forEach(trigger => {
    trigger.setAttribute('data-dialog-trigger-initialized', '');
    trigger.addEventListener('pointerenter', () => {
      const targetId = trigger.getAttribute('commandfor');
      const targetDialog = targetId ? document.getElementById(targetId) : null;
      if (targetDialog) Dialog.prefetch(targetDialog);
    }, { once: true });

    trigger.addEventListener('click', () => {
      const targetId = trigger.getAttribute('commandfor');
      const targetDialog = targetId ? document.getElementById(targetId) : null;
      if (!targetDialog) return;
      Dialog.loadQuickShop(targetDialog).then(() => {
        if (!targetDialog.open) targetDialog.showModal();
      });
    });
  });
};

window.initDialogs();

window.addEventListener('window:load-more', event => {
  initDialogs(event.detail.container);
});

window.addEventListener('shopify:section:load', event => {
  const sectionId = event.detail?.sectionId;
  if (!sectionId) return;
  const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
  if (sectionEl) {
    initDialogs(sectionEl);
  }
});

// Invoker Commands (command="show-modal" / command="close" with commandfor) are not supported in Safari before
// version 26, so on those browsers the modal close buttons do nothing. Open and close those dialogs by hand.
if (!('command' in HTMLButtonElement.prototype)) {
  document.addEventListener('click', event => {
    const invoker = event.target.closest('button[command][commandfor]');
    if (!invoker) return;

    const dialog = document.getElementById(invoker.getAttribute('commandfor'));
    if (!(dialog instanceof HTMLDialogElement)) return;

    const command = invoker.getAttribute('command');
    if (command === 'show-modal' && !dialog.open) dialog.showModal();
    if (command === 'close' && dialog.open) dialog.close();
  });
}
